import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import { objectToQueryString } from "helpers/queryString";
import Env from "../../../consts/env";

import {
	ActionsSearchBrandService,
	failureSearchBrandService, loadGetSearchBrandService, loadSearchBrandServiceSuccess,
} from "./actions";

function* loadDataSearchBrandsServices(params = {}) {

	try {

		yield put(loadGetSearchBrandService());
		const queryParams = objectToQueryString({
			next_id: params.payload.next_id,
			page: !params.payload.next_id ? params.payload.page : 1,
			limit: params.payload.limit,
			type: params.payload.type,
			sort: params.payload.sort,
			keyword: params.payload.keyword,
		});
		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/searchBrands?${queryParams}`;

		const headers = { ...Env.HEADERS, page: params.payload.page };
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(30000),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureSearchBrandService(yield "Error Timeout..."));

		} else {

			const dataSearchBrands = yield response.json();

			if (response.status !== 200) {

				yield put(failureSearchBrandService(yield response.statusText));

			} else {

				yield put(loadSearchBrandServiceSuccess(yield dataSearchBrands));

			}

		}

	} catch (err) {

		yield put(failureSearchBrandService(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsSearchBrandService.GET_SEARCH_BRANDS_SERVICE,
		loadDataSearchBrandsServices);

}
